<template>
    <v-col>
      <Breadcrumbs :title="'Customers'"></Breadcrumbs>
      <PageTitle :title="'Customer Info'" class="pt-3 mx-3"></PageTitle>
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-row>
        <div class="col-md-12 col-lg-4">
          <CustomerInfo></CustomerInfo>
        </div>
        <div class="col-md-12 col-lg-8">
          <CustomerProjects></CustomerProjects>
        </div>
      </v-row>
    </v-col>
  </template>

  <script>
  
 
  import CustomerInfo from "@/components/customers/CustomerInfo";
  import CustomerProjects from "@/components/customers/CustomerProjects";
  import PageTitle from "@/components/shared/PageTitle";  
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "Customer",
    components: {
    CustomerInfo,
    CustomerProjects,
    PageTitle
},
    data: function () {
      return {
      };
    },
    computed: {
      ...mapGetters({
        loading: "loading",
        profile: "profile"
      })
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  
    watch: {
  
    },
  
    methods: {
  
    },
  
  };
  </script>